<template>
    <div class="border border-secondary bg-white rounded px-4 py-3 pricing_group">
        <div class="font-weight-bolder font-size-lg text-uppercase">
            {{ name }}
        </div>
        <div class="text-uppercase font-size-xs text-muted mb-1">
            {{ __('subscriptions.pricing_groups.' + name) }}
        </div>
        <div class="d-flex flex-row gap-1">
            <PricingBox v-for="pricing in pricings"
                        :key="pricing.id"
                        :pricing="pricing"
            />
        </div>
    </div>
</template>

<script>
import PricingBox from "./PricingBox.vue";

export default {
    components: {PricingBox},

    props: {
        name: String,
        pricings: Array
    }
}
</script>

<style>
.pricing_group{
    min-width: 180px;
}
</style>
